let impersonatedUserId: number | null = null;

export function getImpersonatedUserId() {
    if (impersonatedUserId === null) {
        const search = new URLSearchParams(window.location.search);
        const impersonatedUserIdFromSearch = search.get("impersonatedUserId");
        const impersonatedUserIdFromSession = sessionStorage.getItem("impersonatedUserId");

        impersonatedUserId = +(impersonatedUserIdFromSearch || impersonatedUserIdFromSession || 0);

        if (impersonatedUserIdFromSearch) {
            search.delete("impersonatedUserId");
        }

        if (!impersonatedUserIdFromSession || impersonatedUserIdFromSearch) {
            sessionStorage.setItem("impersonatedUserId", impersonatedUserId.toString());
        }

        if (impersonatedUserIdFromSearch && impersonatedUserIdFromSearch !== impersonatedUserIdFromSession) {
            window.location.search = search.toString();
        }
    }

    return impersonatedUserId;
}